<template>
  <div class="table-box">
    <!--列表-->
    <div class="">
      <el-table
        v-loading="loading"
        :data="tableData"
        border=""
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="taskMonth" label="任务月度"></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="计划任务量"
          v-if="projectType !== 19"
        >
          <template slot-scope="scope">{{ scope.row.taskSum || 0 }}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" label="实际完成任务量">
          <template slot-scope="scope">
            {{
            scope.row.finishSum
            ? scope.row.finishSum > scope.row.taskSum
            ? scope.row.taskSum
            : scope.row.finishSum
            : 0
            }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="结算单价（税前）"
          v-if="projectType !== 19"
        >
          <template slot-scope="scope">{{ (parseInt(Number(scope.row.price)) / 100).toFixed(2) }}元</template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="结算金额（税前）"
          v-if="projectType === 19"
        >
          <template slot-scope="{ row }">{{ row.incomePrice | money }}元</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" label="状态">
          <template slot-scope="scope">{{ scope.row.industryFinish | transAuditStatus }}</template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="200" align="center" v-if="projectType !== 19">
          <template slot-scope="scope">
            <div v-if="scope.row.industryFinish == 0">
              <el-button
                type="text"
                size="small"
                :disabled="scope.row.projectStatus <= 0"
                @click="importExport(scope.row)"
              >编辑</el-button>
            </div>
          </template>
        </el-table-column>-->
      </el-table>
    </div>
    <YshTaskDialog
      v-if="showDialog"
      :rowData="rowData"
      @task-close="taskClose"
      :projectType="projectType"
    ></YshTaskDialog>
  </div>
</template>
<script>
import { bingli, project, zsBingli } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import YshTaskDialog from '@/components/Task/TaskDialog';
export default {
  mixins: [pageInation, makeSure],
  props: {
    projectType: {
      // type 病例——8,调查问卷5 ys调查问卷7
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      ruleForm: {}, // 用户信息
      showDialog: false,
      rowData: {}
    };
  },
  components: {
    dicSelect,
    YshTaskDialog
  },
  computed: {
    searchQuery () {
      return {
        projectId: this.$route.query.id
      };
    },
    getList () {
      //获取列表
      if (this.projectType == 8) {
        return bingli.bingliProjectTask;
      } else if (this.projectType == 5) {
        return project.dcwjIndustryList;
      } else if (this.projectType == 7) {
        return project.yshDcwjIndustryList;
      } else {
        return project.projectIndustryList;
      }
    },
    submitAjax () {
      //编辑的接口
      if (this.projectType == 8) {
        //病例
        return bingli.yshProjectIndustryUpdate;
      } else if (this.projectType == 5) {
        return project.dcwjProjectIndustryUpdate;
      } else if (this.projectType == 7) {
        return project.yshProjectIndustryUpdate;
      } else if (this.projectType == 18) {
        return zsBingli.yshProjectIndustryUpdate;
      } else {
        return project.projectIndustryUpdate;
      }
    }
  },
  methods: {
    importExport (row) {
      //弹层弹出
      this.rowData = row;
      this.showDialog = true;
    },
    send (scope) {
      let sendEvent = scope => {
        let { $index, row } = scope;
        bingli
          .updateBingliProjectTaskStatus({
            id: row.id,
            projectType: this.projectType
          })
          .then(res => {
            this.$notify({
              title: '成功',
              message: '任务提交成功',
              type: 'success'
            });
            this.initWatchRouteChange();
          });
      };
      this.makeSureEvent(sendEvent, scope);
    },
    taskClose () {
      this.showDialog = false;
    }
  },
  filters: {
    transAuditStatus (val) {
      if (val == 0) {
        return '未下发';
      } else {
        return '已下发';
      }
    }
  },
  created () { }
};
</script>
